import React from "react";
import "./styles.scss";

const Index = (props) => (
  <>
    <div className={`details-header-wrapper ${props.option} ${props.size}`}>
      <div className={"header"}>{props.header}</div>

      {props.isWizard && (
        <div className={"wizard-header"}>
          {props.noOfPage} / {props.totalWizard}
        </div>
      )}
    </div>
  </>
);
export default Index;
